<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
        <span>Regras Tributárias Relacionadas</span>
        <div class="section-title-actions ms-auto">
            <button mat-button type="button" class="btn-section" (click)="relacionar.emit()">
                <mat-icon>add</mat-icon>
                Relacionar regra
            </button>
        </div>
    </div>

    @if (regrasRelacionadas.length === 0) {
    <div class="excecoes-empty">
        <mat-icon class="material-symbols-outlined empty-icon">account_tree</mat-icon>
        <p class="empty-titulo">Nenhuma regra relacionada</p>
        <p class="empty-subtitulo">
            Relacione outras regras tributárias que se aplicam a esta natureza de operação
            além da regra padrão.
        </p>
    </div>
    } @else {

    <!-- Tabela desktop -->
    <table mat-table class="desktop-view" [dataSource]="regrasRelacionadas">

        <ng-container matColumnDef="regra">
            <th mat-header-cell *matHeaderCellDef>Regra</th>
            <td mat-cell *matCellDef="let r">
                <div class="text-bold">{{ r.nome }}</div>
                @if (r.observacao) {
                    <div class="text-secondary" style="font-size:0.82rem;">{{ r.observacao }}</div>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="classificacao">
            <th mat-header-cell *matHeaderCellDef>Classificação</th>
            <td mat-cell *matCellDef="let r">
                <span class="status-badge badge-azul">CST {{ r.cst }}</span>
                <span class="status-badge badge-roxo ms-1">{{ r.cclassTrib }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="modelos">
            <th mat-header-cell *matHeaderCellDef>Modelos</th>
            <td mat-cell *matCellDef="let r">
                @for (modelo of r.modelosDocumento; track $index) {
                    <span class="status-badge badge-cinza me-1">{{ nomeModeloPorCodigo[modelo] ?? modelo }}</span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let r">
                <span class="status-badge" [class.badge-verde]="r.isAtivo" [class.badge-vermelho]="!r.isAtivo">
                    {{ r.isAtivo ? 'Ativa' : 'Inativa' }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let r" class="text-center w-actions">
                <button mat-icon-button [matMenuTriggerFor]="menuRegra" type="button" aria-label="Ações">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menuRegra="matMenu">
                    <button mat-menu-item (click)="editarRegra.emit(r)">
                        <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
                        <span>Editar no cadastro</span>
                    </button>
                    <button mat-menu-item (click)="removerRegra.emit(r)">
                        <mat-icon class="material-symbols-outlined">link_off</mat-icon>
                        <span>Desvincular</span>
                    </button>
                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <!-- Cards mobile -->
    <div class="mobile-view">
        @for (r of regrasRelacionadas; track r.idRegraTributaria) {
        <div class="card-mobile mb-3">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
                <span class="text-bold">{{ r.nome }}</span>
                <button mat-icon-button [matMenuTriggerFor]="menuMob" type="button">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menuMob="matMenu">
                    <button mat-menu-item (click)="editarRegra.emit(r)">
                        <span class="material-symbols-outlined">open_in_new</span>
                        <span>Editar no cadastro</span>
                    </button>
                    <button mat-menu-item (click)="removerRegra.emit(r)">
                        <span class="material-symbols-outlined">link_off</span>
                        <span>Desvincular</span>
                    </button>
                </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
                <p class="mb-1"><strong>CST IBS/CBS:</strong> <span class="status-badge badge-azul ms-1">{{ r.cst }}</span></p>
                <p class="mb-1"><strong>Cód. Classificação Trib. IBS/CBS:</strong> <span class="status-badge badge-roxo ms-1">{{ r.cclassTrib }}</span></p>
                <p class="mb-0 d-flex flex-wrap gap-1 align-items-center">
                    <strong class="me-1">Modelos de Documento:</strong>
                    @for (modelo of r.modelosDocumento; track $index) {
                        <span class="status-badge badge-cinza">{{ nomeModeloPorCodigo[modelo] ?? modelo }}</span>
                    }
                    @if (r.modelosDocumento.length === 0) {
                        <span class="text-secondary">—</span>
                    }
                </p>
            </div>
        </div>
        }
    </div>
    }
</div>
